// The comparing moment (#5195; founder pick A): on the second different
// college page of a visit, a "Your colleges" strip under the header with the
// schools opened this visit (newest first, at most 3, what /start can offer), each with its band
// where the visitor ran the free read there, and one action, "Save these to
// my list". The schools are OFFERED on /start after sign-up (the Desk's
// answer to open question 5): nothing is added or charged without the
// student's tap (product invariant 10). With no read yet this visit, "Check
// with my grades" opens this page's card first.
import React from 'react';
import { Link } from 'react-router-dom';
import MomentBox from './MomentBox';
import { COPY, MOMENTS } from '../../content/signupMoments';
import { BAND_CHIP_UNKNOWN } from '../../utils/fitBands';

const BAND_CHIP = {
    Safety: 'bg-[#E8F0E9] text-[#1A4D2E] border-[#CFE0D2]',
    Target: 'bg-[#1A4D2E] text-white border-[#1A4D2E]',
    Reach: 'bg-[#FCEEE8] text-[#C05838] border-[#F0D5C8]',
};

export default function ComparingStrip({ visit, current, onSave, onCheck, className = '' }) {
    const schools = visit.colleges;
    const box = MOMENTS.comparing.box({ schools, gpa: visit.gpa || null,
        targets: Number.isInteger(visit.targetsN) ? { n: visit.targetsN } : null });
    if (!box) return null;
    const anyRead = schools.some((s) => s.band);
    return (
        <MomentBox moment="comparing" box={box} onGo={onSave} testid="comparing-moment" className={className}
            props={{ schools_n: schools.length }}
            extra={anyRead ? null : { label: COPY.stripCheck, onClick: onCheck }}>
            <ul className="mt-2 flex flex-wrap gap-2" data-testid="comparing-moment-schools">
                {schools.map((s) => (
                    <li key={s.slug} className="flex items-center gap-1.5 text-sm text-[#2C2C2C]">
                        {s.slug === current
                            ? <span className="font-semibold">{s.short}</span>
                            : <Link to={`/colleges/${s.slug}`} className="font-semibold underline underline-offset-2">{s.short}</Link>}
                        {s.band && (
                            <span className={`rounded-full border px-2 py-0.5 text-xs font-semibold ${BAND_CHIP[s.band] || BAND_CHIP_UNKNOWN}`}>{s.band}</span>
                        )}
                    </li>
                ))}
            </ul>
        </MomentBox>
    );
}
